import { EntityState } from '@reduxjs/toolkit';

export const unwrap = <T>(state: EntityState<T>): T[] => {
    return Object.values(state.entities) as T[];
};